import {
  RiFileList3Line,
  RiBuilding2Line,
  RiUserLine,
  RiUserAddLine,
  RiTeamLine,
  RiRefreshLine,
} from "react-icons/ri";
import { TbCopyright } from "react-icons/tb";
import { IoAlarmOutline, IoOpenOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { useCapturarProposta } from "services/api/Funil_Propostas/capturar-proposta-post";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { obterNomeEtapaExibicao } from "utils/obterNomeEtapaExibicao";
import * as S from "./styles";
import { badgeColors } from "./colors";

interface ListaFila {
  nomeLead: string;
  codigoLead: string;
  numeroCotacao: string;
  empreendimento: string;
  bloco: string;
  unidade: string;
  corretor: string;
  equipe: string | null;
  imobiliaria: string;
  subetapa: string;
  tempoSimulacao: string;
  tempoEtapa: string;
  idLeadCorretor: string;
  idOportunidade: string;
  clienteNaMesa: boolean;
  responsavelAnaliseAtual?: string | null;
}

interface Data {
  listaFila: ListaFila;
  isFetchingKanbanListar: boolean;
  showCaptureAction: boolean;
  onCaptureSuccess: (idOportunidade: string) => void;
}

const ItemCard = (data: Data) => {
  const mutateCapturarProposta = useCapturarProposta();
  const { usuarioVivaz } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const generateBadgeColor = () => {
    return badgeColors[data?.listaFila?.subetapa?.toLowerCase()] || "#a3a3a6";
  };

  const hasResponsavelAtual = Boolean(
    data.listaFila.responsavelAnaliseAtual?.trim()
  );

  const handleCapturarProposta = () => {
    mutateCapturarProposta.mutate(
      { idOportunidade: data.listaFila.idOportunidade },
      {
        onSuccess: () => {
          data.onCaptureSuccess(data.listaFila.idOportunidade);
        },
      }
    );
  };

  return (
    <S.Body>
      <S.Row>
        <S.TextStatus backgroundColor={generateBadgeColor}>
          {obterNomeEtapaExibicao(data.listaFila.subetapa, usuarioVivaz) ||
            "--"}
        </S.TextStatus>
      </S.Row>
      <S.SpaceY space={12} />
      <S.Row style={{ justifyContent: "space-between" }}>
        <Tooltip arrow title={data.listaFila.nomeLead || ""}>
          <S.TextName width={"150px"}>{data.listaFila.nomeLead}</S.TextName>
        </Tooltip>
        <S.TextCodigo>{data.listaFila.codigoLead}</S.TextCodigo>
      </S.Row>
      <S.SpaceY space={12} />
      <S.Row style={{ gap: 8 }}>
        <RiFileList3Line size={20} color="#000000" />
        <S.TextFine>{data.listaFila.numeroCotacao}</S.TextFine>
      </S.Row>
      <S.SpaceY space={12} />
      <S.Row style={{ alignItems: "flex-start", gap: 8 }}>
        <div>
          <S.Row style={{ marginTop: 4, gap: 8 }}>
            <RiBuilding2Line size={20} color="#000000" />
            <Tooltip arrow title={data.listaFila.empreendimento || ""}>
              <S.TextStrong width={"200px"} style={{ marginTop: 4 }}>
                {data.listaFila.empreendimento}
              </S.TextStrong>
            </Tooltip>
          </S.Row>
          <S.Row style={{ marginTop: 4, gap: 8 }}>
            <S.TextStrong>BLOCO: </S.TextStrong>
            <Tooltip arrow title={data.listaFila.bloco || ""}>
              <S.TextFine width={"150px"}>{data.listaFila.bloco}</S.TextFine>
            </Tooltip>
          </S.Row>
          <S.Row style={{ marginTop: 4, gap: 8 }}>
            <S.TextStrong>UNIDADE: </S.TextStrong>
            <S.TextFine>{data.listaFila.unidade}</S.TextFine>
          </S.Row>
        </div>
      </S.Row>
      <S.SpaceY space={12} />
      <S.Row style={{ gap: 8 }}>
        <RiUserLine size={20} color="#000000" />
        <S.TextStrong>CORRETOR:</S.TextStrong>
        <Tooltip arrow title={data.listaFila.corretor || ""}>
          <S.TextFine width={"130px"}>{data.listaFila.corretor}</S.TextFine>
        </Tooltip>
      </S.Row>
      <S.SpaceY space={12} />
      <S.Row style={{ gap: 8 }}>
        <RiTeamLine size={20} color="#000000" />
        <S.TextStrong>EQUIPE:</S.TextStrong>
        <Tooltip arrow title={data.listaFila.equipe || ""}>
          <S.TextFine width={"150px"}>{data.listaFila.equipe}</S.TextFine>
        </Tooltip>
      </S.Row>
      <S.SpaceY space={12} />
      <S.Row style={{ gap: 8 }}>
        <TbCopyright size={20} color="#000000" />
        <S.TextStrong>IMOBILIÝRIA:</S.TextStrong>
        <Tooltip arrow title={data.listaFila.imobiliaria || ""}>
          <S.TextFine width={"120px"}>{data.listaFila.imobiliaria}</S.TextFine>
        </Tooltip>
      </S.Row>
      <S.SpaceY space={12} />
      {data.listaFila.clienteNaMesa ? (
        <>
          <S.Row style={{ gap: 8 }}>
            <S.TextWarning textColor={"#ff0000"} color={"#FFEBEE"}>
              Cliente na mesa
            </S.TextWarning>
          </S.Row>
        </>
      ) : (
        <div style={{ height: 18 }} />
      )}

      {data.showCaptureAction ? (
        <>
          <S.SpaceY space={8} />
          {hasResponsavelAtual ? (
            <S.ResponsavelBadge>
              <RiUserAddLine size={17} color="#2D5BFF" />
              <Tooltip
                arrow
                title={`RESP.: ${data.listaFila.responsavelAnaliseAtual}`}
              >
                <S.ResponsavelText>
                  RESP.: {data.listaFila.responsavelAnaliseAtual}
                </S.ResponsavelText>
              </Tooltip>
            </S.ResponsavelBadge>
          ) : (
            <S.CaptureButton
              onClick={handleCapturarProposta}
              disabled={mutateCapturarProposta.isLoading}
            >
              <S.CaptureButtonText>
                {mutateCapturarProposta.isLoading
                  ? "Assumindo atendimento..."
                  : "Assumir atendimento →"}
              </S.CaptureButtonText>
            </S.CaptureButton>
          )}
        </>
      ) : null}

      <S.SpaceY space={data.showCaptureAction ? 8 : 12} />
      <S.Divider />
      <S.SpaceY space={12} />
      <S.Row
        style={{ display: "flex", justifyContent: "space-between", gap: 8 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <IoAlarmOutline size={20} color="#2196F3" />
          <S.TextFine>{data.listaFila.tempoSimulacao}</S.TextFine>
          <RiRefreshLine size={20} color="#2196F3" />
          <S.TextFine>{data.listaFila.tempoEtapa}</S.TextFine>
        </div>
        <Link
          to={{
            pathname: `/lead-detail/${data.listaFila.idLeadCorretor}/proposition-detail/${data.listaFila.numeroCotacao}/`,
            state: { from: "/funil-comercial" },
          }}
        >
          <S.Button>
            <IoOpenOutline size={20} color="#000000" />
          </S.Button>
        </Link>
      </S.Row>
    </S.Body>
  );
};

export default ItemCard;
